import { UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';

export class BusinessPaymentOptionsSummary {
    public businessId: number = 0;
    public hasPaymentAtLocation: boolean = false;
    public hasPaymentOnHandingOver: boolean = false;
    public hasBankTransferPayments: boolean = false;
    public hasPayPalPayments: boolean = false;
    public hasRedsysCreditCartPayments: boolean = false;
    public hasRedsyBizumPayments: boolean = false;
    public hasPersonalBizumPayments: boolean = false;

    public get permissionsGroupType(): UserEntityPermissionsType {
        return UserEntityPermissionsType.Businesses;
    }

    public get permissionsIdToCheck(): number {
        return this.businessId;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): BusinessPaymentOptionsSummary {
        const paymentOptions: BusinessPaymentOptionsSummary = new BusinessPaymentOptionsSummary();

        paymentOptions.hasPaymentAtLocation = this.hasPaymentAtLocation;
        paymentOptions.hasPaymentOnHandingOver = this.hasPaymentOnHandingOver;
        paymentOptions.hasBankTransferPayments = this.hasBankTransferPayments;
        paymentOptions.hasPayPalPayments = this.hasPayPalPayments;
        paymentOptions.hasRedsysCreditCartPayments = this.hasRedsysCreditCartPayments;
        paymentOptions.hasRedsyBizumPayments = this.hasRedsyBizumPayments;
        paymentOptions.hasPersonalBizumPayments = this.hasPersonalBizumPayments;

        return paymentOptions;
    }
}
